import { UploadStore, RecordsRefresher } from "@/presentation/upload/stores/UploadStore";
import { UploadFileUseCase } from "@/application/upload/usecases/UploadFileUseCase";
import { ConfirmTextFileUploadUseCase } from "@/application/upload/usecases/ConfirmTextFileUploadUseCase";
import { CancelUploadUseCase } from "@/application/upload/usecases/CancelUploadUseCase";
import { InsightFileUploadRepository } from "@/infrastructure/upload/InsightFileUploadRepository";
import { FirebaseStorageUploadService } from "@/infrastructure/upload/FirebaseStorageUploadService";
import { BrowserTextFileReader } from "@/infrastructure/upload/BrowserTextFileReader";
import { BrowserMediaDurationService } from "@/infrastructure/upload/BrowserMediaDurationService";
import { ExtensionFileTypeDetector } from "@/application/upload/services/ExtensionFileTypeDetector";
import { UuidGeneratorAdapter } from "@/infrastructure/upload/UuidGeneratorAdapter";
import { InMemoryUploadControllerRegistry } from "@/infrastructure/upload/InMemoryUploadControllerRegistry";

export interface UploadStoreFactoryParams {
  refreshRecords: RecordsRefresher;
}

export const createUploadStore = ({
  refreshRecords,
}: UploadStoreFactoryParams): UploadStore => {
  const repository = new InsightFileUploadRepository();
  const storageUploadService = new FirebaseStorageUploadService();
  const textFileReader = new BrowserTextFileReader();
  const mediaDurationService = new BrowserMediaDurationService();
  const fileTypeDetector = new ExtensionFileTypeDetector();
  const uuidGenerator = new UuidGeneratorAdapter();
  const controllerRegistry = new InMemoryUploadControllerRegistry();

  const uploadFileUseCase = new UploadFileUseCase(
    repository,
    storageUploadService,
    textFileReader,
    mediaDurationService,
    fileTypeDetector,
    uuidGenerator
  );

  const confirmTextFileUploadUseCase = new ConfirmTextFileUploadUseCase(
    repository
  );

  const cancelUploadUseCase = new CancelUploadUseCase(controllerRegistry);

  return new UploadStore(
    uploadFileUseCase,
    confirmTextFileUploadUseCase,
    cancelUploadUseCase,
    controllerRegistry,
    refreshRecords
  );
};

